export const ROUTER_FEATURE_KEY = 'router';
